import React from "react";
import FSTable from "./FSTable";

const COLUMNS = [
  { label: "User Email",   field: "userEmail",    align: "left",  editable: false, type: "text" },
  { label: "Date",         field: "date",         align: "left",  editable: false, type: "text" },
  { label: "Description",  field: "description",  align: "left",  editable: false, type: "text" },
  { label: "1st Item",     field: "firstItem",    align: "left",  editable: false, type: "text" },
  { label: "2nd Item",     field: "secondItem",   align: "left",  editable: false, type: "text" },
  { label: "1st Value",    field: "firstValue",   align: "right", editable: false, type: "number" },
  { label: "2nd Value",    field: "secondValue",  align: "right", editable: false, type: "number" },
  { label: "Message",      field: "message",      align: "left",  editable: false, type: "text" },
];

const AdjustmentLog = ({ data = [] }) => {
  return (
    <div style={{ height: "100%", overflowY: "auto", padding: "0px 20px" }}>
      <FSTable
        columns={COLUMNS}
        rows={data}
        onRowsChange={() => {}}
        onCellChangeImmediate={() => {}}
      />
    </div>
  );
};

export default AdjustmentLog;